import React from 'react';

import { Button, Flex, Icon, Image, Link, Menu, Portal } from '@chakra-ui/react';
import { GiHamburgerMenu } from "react-icons/gi";

import './styles/NavigationBar.css';

function NavigationBar() {
  return (
    <div>
        <Flex className="navigation_bar__header_parent" justifyContent='space-between'>
            {/* Desktop menu */}
            <Link  href='#'>
                <Image height='30px' src={'/logo.png'}/>
            </Link>
            <Flex gap='6'>
                <Link color='black' href='#howdoesitwork'>
                    How does it Work?
                </Link>
                <Link color='black' href='#testimonials'>
                    Testimonials
                </Link>
                <Link color='black' href='#commissioncalculator'>
                    Commission Calculator
                </Link>
                <Link color='black' href='#faq'>
                    FAQ
                </Link>
                <Link color='black' href='#contactus'>
                    Contact Us
                </Link>
            </Flex>
        </Flex>

        {/* Mobile hamburger menu */}
        <Flex className='navigation_bar__mobile_header_parent' justifyContent='space-between'>
            <Link  href='#'>
                <Image height='25px' src={'/logo.png'}/>
            </Link>
            <Menu.Root>
                <Menu.Trigger asChild>
                    <Icon size='lg'>
                        <GiHamburgerMenu color='black'/>
                    </Icon>
                </Menu.Trigger>
                <Portal>
                    <Menu.Positioner>
                    <Menu.Content>
                        <Menu.Item value="new-txt-a">
                            <Link color='black' href='#howdoesitwork'>
                                How does it Work?
                            </Link>
                        </Menu.Item>
                        <Menu.Item value="new-file-a">
                            <Link color='black' href='#testimonials'>
                                Testimonials
                            </Link>
                        </Menu.Item>
                        <Menu.Item value="new-win-a">
                            <Link color='black' href='#commissioncalculator'>
                                Commission Calculator
                            </Link>
                        </Menu.Item>
                        <Menu.Item value="open-file-a">
                            <Link color='black' href='#faq'>
                                FAQ
                            </Link>
                        </Menu.Item>
                        <Menu.Item value="export-a">
                            <Link color='black' href='#contactus'>
                                Contact Us
                            </Link>
                        </Menu.Item>
                    </Menu.Content>
                    </Menu.Positioner>
                </Portal>
            </Menu.Root>
        </Flex>
    </div>
  );
}

export default NavigationBar;
